import { createSlice } from '@reduxjs/toolkit'
import { fetchCart, clearCart, updateCart, addProductToCart } from '../actions/cartActions'

const CartReducers = createSlice({
    name: 'CartReducers',
    initialState: {
        loader: false,
        errors: null,
        cart: null,
    },
    reducers: {
         /**
         * Empty Cart
         */
         emptyCart(state) {
            state.cart = null;
            state.loader = false;
            state.errors = null;
        }
    },
    extraReducers: (builder) => {
        builder
            /**
             * Fetch Cart Details
             */
            .addCase(fetchCart.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(fetchCart.fulfilled, (state, action) => {
                state.loader = false;
                state.cart = action.payload;
                // console.log("Fetch cart Success Reducers: ", action.payload)
            })
            .addCase(fetchCart.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
                console.log("Fetch cart Failed Reducers: ", action.payload)
            })

            /**
             * Clear Cart Details
             */
            .addCase(clearCart.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(clearCart.fulfilled, (state) => {
                state.loader = false;
                state.cart = null; // Reset the cart state
            })
            .addCase(clearCart.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })

            /**
             * Update Cart Details
             */
            .addCase(updateCart.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(updateCart.fulfilled, (state, action) => {
                state.loader = false;
                state.cart = action.payload;

                // console.log("Update Reducers: ", action.payload)
            })
            .addCase(updateCart.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })

            /**
             * Add Product to Cart
             */
            .addCase(addProductToCart.pending, (state) => {
                state.loader = true;
                state.errors = null;
            })
            .addCase(addProductToCart.fulfilled, (state, action) => {
                state.loader = false;
                state.cart = action.payload;
            })
            .addCase(addProductToCart.rejected, (state, action) => {
                state.loader = false;
                state.errors = action.payload;
            })
    }
});

export const { emptyCart } = CartReducers.actions;

export default CartReducers.reducer
